import { HttpClient, HttpClientModule } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { ServiceWorkerModule } from '@angular/service-worker';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { FacebookLoginProvider, GoogleLoginProvider, SocialAuthServiceConfig, SocialLoginModule } from 'angularx-social-login';
import { NgxSpinnerModule } from 'ngx-spinner';
import { environment } from 'src/environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeModule } from './module/home/home.module';
import { ImeiCheckModule } from './module/imei-check/imei-check.module';
import { OrderDisplayModule } from './module/order-display/order-display.module';
import { OrderFormModule } from './module/order-form/order-form.module';
import { OrderTrackingModule } from './module/order-tracking/order-tracking.module';
import { SignInModule } from './module/sign-in/sign-in.module';
import { PhoneService } from './shared/services/phone.service';
import { HeaderComponent } from './shared/components/header/header.component';
import { Helper } from './shared/helpers/helper.service';
import { SharedModule } from './shared/shared.module';

export function httpTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
@NgModule({
  imports: [
    RouterModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    NgxSpinnerModule,
    ServiceWorkerModule.register('./ngsw-worker.js', {
      enabled: environment.production, // Register the ServiceWorker as soon as the app is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpTranslateLoader,
        deps: [HttpClient]
      }
    }),
    SocialLoginModule,

    HomeModule,
    OrderTrackingModule,
    OrderFormModule,
    OrderDisplayModule,
    ImeiCheckModule,
    SignInModule,
    SharedModule.forRoot(),
  ],
  providers: [
    PhoneService,
    Helper,
    {
      provide: 'SocialAuthServiceConfig',
      useValue: {
        autoLogin: true,
        providers: [
          {
            id: GoogleLoginProvider.PROVIDER_ID,
            provider: new GoogleLoginProvider(environment.googleClientId),
          },
          {
            id: FacebookLoginProvider.PROVIDER_ID,
            provider: new FacebookLoginProvider(environment.facebookCleintId),
          },
        ]
      } as SocialAuthServiceConfig,
    }
  ],
  declarations: [
    AppComponent, HeaderComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent]
})
export class AppModule { }
